import connectedComponent from './Slider';

export default connectedComponent;